import RomanImg from '../../images/118565.jpg';
import IgorImg from '../../images/856.png';
import VladislavImg from '../../images/9565.png';
import GeorgiImg from '../../images/9632.png';

import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

function ArticlePage18() {
  useEffect(() => {
    function isGoogleTranslated() {
      const html = document.documentElement;
      const body = document.body;

      return (
        html.classList.contains('translated-ltr') ||
        html.classList.contains('translated-rtl') ||
        body.classList.contains('translated-ltr') ||
        body.classList.contains('translated-rtl') ||
        document.cookie.indexOf('googtrans=') !== -1 ||
        html.getAttribute('lang') !== 'ru'
      );
    }

    function fixValue(text) {
      if (!text) return text;

      return text
        .replace(/\bRoman Shlykov's\b/g, "Roman Shlykov's")
        .replace(/\bROMAN SHLYKOV'S\b/g, "ROMAN SHLYKOV'S")
        .replace(/\bRoman Shlykov\b/g, 'Roman Shlykov')
        .replace(/\bROMAN SHLYKOV\b/g, 'ROMAN SHLYKOV')
        .replace(/\bRoman's\b/g, "Roman's")
        .replace(/\bROMAN'S\b/g, "ROMAN'S")
        .replace(/\bRoman\b/g, 'Roman')
        .replace(/\bROMAN\b/g, 'ROMAN');
    }

    function shouldSkipNode(parent) {
      if (!parent || !parent.tagName) return true;

      const tag = parent.tagName.toUpperCase();
      return (
        tag === 'SCRIPT' ||
        tag === 'STYLE' ||
        tag === 'NOSCRIPT' ||
        tag === 'TEXTAREA' ||
        tag === 'CODE' ||
        tag === 'PRE'
      );
    }

    function fixTextNodes(root) {
      if (!root) return;

      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node || !node.nodeValue || !node.nodeValue.trim()) {
              return NodeFilter.FILTER_REJECT;
            }

            if (shouldSkipNode(node.parentNode)) {
              return NodeFilter.FILTER_REJECT;
            }

            if (
              node.nodeValue.indexOf('Roman') === -1 &&
              node.nodeValue.indexOf('ROMAN') === -1
            ) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          },
        }
      );

      const nodes = [];
      let current;

      while ((current = walker.nextNode())) {
        nodes.push(current);
      }

      nodes.forEach((node) => {
        const fixed = fixValue(node.nodeValue);
        if (fixed !== node.nodeValue) {
          node.nodeValue = fixed;
        }
      });
    }

    function fixAttributes() {
      const selectors = [
        'title',
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]',
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (el.tagName.toLowerCase() === 'title') {
            const fixedText = fixValue(el.textContent);
            if (fixedText !== el.textContent) {
              el.textContent = fixedText;
            }
          } else {
            const content = el.getAttribute('content');
            const fixedContent = fixValue(content);
            if (fixedContent !== content) {
              el.setAttribute('content', fixedContent);
            }
          }
        });
      });

      if (document.title) {
        const fixedTitle = fixValue(document.title);
        if (fixedTitle !== document.title) {
          document.title = fixedTitle;
        }
      }
    }

    function runFixes() {
      if (!isGoogleTranslated()) return;
      fixTextNodes(document.body);
      fixAttributes();
    }

    let started = false;
    let mainObserver = null;
    let pollInterval = null;
    let translationWatcher = null;

    function startAfterTranslate() {
      if (started) return;
      started = true;

      runFixes();

      mainObserver = new MutationObserver(() => {
        runFixes();
      });

      if (document.body) {
        mainObserver.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      let count = 0;
      pollInterval = setInterval(() => {
        runFixes();
        count += 1;

        if (count > 180) {
          clearInterval(pollInterval);
        }
      }, 1000);
    }

    function waitForTranslate() {
      if (isGoogleTranslated()) {
        startAfterTranslate();
        return;
      }

      translationWatcher = new MutationObserver(() => {
        if (isGoogleTranslated()) {
          startAfterTranslate();
        }
      });

      translationWatcher.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'lang'],
      });

      const translateCheckInterval = setInterval(() => {
        if (isGoogleTranslated()) {
          startAfterTranslate();
          clearInterval(translateCheckInterval);
        }
      }, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForTranslate);
    } else {
      waitForTranslate();
    }

    return () => {
      if (mainObserver) mainObserver.disconnect();
      if (translationWatcher) translationWatcher.disconnect();
      if (pollInterval) clearInterval(pollInterval);
    };
  }, []);

  return (
    <div className="xContent p-box py-6">
      <Helmet>
        <title>
          Роман Шлыков (Roman Shlykov) — обладатель Гран-При 2020 | Лучший маркетолог
        </title>
        <meta
          name="description"
          content="Роман Шлыков (Roman Shlykov) — обладатель Гран-При Международной Премии Маркетинговых Коммуникаций 2020 в номинации «Лучший маркетолог». Специальный проект о победителях, сильном маркетинге и влиянии маркетинга на бизнес."
        />
        <meta
          name="keywords"
          content="Роман Шлыков, Roman Shlykov, лучший маркетолог 2020, гран-при маркетинг, Международная Премия Маркетинговых Коммуникаций, marketing influence, digital strategy, Netpeak"
        />
        <link rel="canonical" href="https://marketing-association.com/article18" />

        <meta
          property="og:title"
          content="Роман Шлыков (Roman Shlykov) — обладатель Гран-При 2020 | Лучший маркетолог"
        />
        <meta
          property="og:description"
          content="Специальный проект о победителях Международной Премии Маркетинговых Коммуникаций 2020 с фокусом на Романа Шлыкова, обладателя Гран-При."
        />
        <meta property="og:url" content="https://marketing-association.com/article18" />
        <meta property="og:type" content="article" />
        <meta property="og:image" content="https://marketing-association.com/images/articlepage18.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Роман Шлыков (Roman Shlykov) — обладатель Гран-При 2020"
        />
        <meta
          name="twitter:description"
          content="Специальный проект о победителях Международной Премии Маркетинговых Коммуникаций 2020 с акцентом на Roman Shlykov."
        />
        <meta name="twitter:image" content="https://marketing-association.com/images/articlepage18.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'NewsArticle',
            headline:
              'Маркетинг влияния. Специальный проект о победителях Международной Премии Маркетинговых Коммуникаций 2020',
            alternativeHeadline:
              'Roman Shlykov and the Winners of the International Marketing Communications Award 2020',
            description:
              'Специальный проект о победителях Международной Премии Маркетинговых Коммуникаций 2020 с фокусом на Романа Шлыкова (Roman Shlykov), обладателя Гран-При в номинации «Лучший маркетолог».',
            inLanguage: 'ru',
            datePublished: '2020-05-29',
            dateModified: '2020-05-29',
            author: {
              '@type': 'Person',
              name: 'Артем Беляев',
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://marketing-association.com/article18',
            },
            image: ['https://marketing-association.com/images/articlepage18.png'],
            mentions: [
              {
                '@type': 'Person',
                name: 'Roman Shlykov',
                alternateName: 'Роман Шлыков',
                award: 'Гран-При в номинации «Лучший маркетолог»'
              },
              {
                '@type': 'Person',
                name: 'Игорь Луковский'
              },
              {
                '@type': 'Person',
                name: 'Владислав Степанов'
              },
              {
                '@type': 'Person',
                name: 'Георги Парсаданишвили'
              }
            ],
          })}
        </script>
      </Helmet>

      <p className="has-text-left content wysiwyg p-1">29 мая 2020 год</p>

      <h1 className="title is-font-title-regular has-text-centered has-text-var-blue p-1">
        Маркетинг влияния
        <br />
        Специальный проект о победителях Международной Премии Маркетинговых Коммуникаций 2020
      </h1>

      <div className="content p-20 wysiwyg">
        <p className="has-text-centered p-style">Автор статьи: Артем Беляев</p>

        <p className="p-1">
          В 2020 году Международная Премия Маркетинговых Коммуникаций вновь обозначила
          главный вектор для индустрии: сильный маркетинг начинается там, где заканчивается
          декоративность и начинается влияние. Премия, учрежденная Международной ассоциацией
          маркетологов СНГ, ежегодно отмечает выдающиеся достижения в маркетинге, рекламе,
          брендинге, PR и digital-маркетинге, а к участию допускаются профессионалы с не менее
          чем трехлетним опытом на управленческих позициях. Победителей определяет экспертный
          совет, в который входят лидеры отрасли, топ-менеджеры брендов и специалисты в области
          маркетинговых коммуникаций.
        </p>

        <p className="p-1">
          Международная Премия Маркетинговых Коммуникаций — это ежегодная профессиональная
          награда, учрежденная Международной ассоциацией маркетологов СНГ для выявления и
          поощрения сильнейших специалистов в области маркетинга, рекламы, брендинга, PR и
          digital-коммуникаций. Премия ориентирована на признание проектов и профессиональных
          достижений, которые сочетают стратегический подход, инновационность, измеримые
          результаты и влияние на развитие отрасли. В материалах премии подчеркивается, что
          ее задача заключается не только в награждении отдельных специалистов, но и в
          формировании профессиональных ориентиров для всего маркетингового сообщества.
        </p>

        <p className="p-1">
          Итоги премии 2020 года были подведены 25 мая 2020 года в Москве. В номинации
          «Лучший маркетолог» главным именем стал Роман Шлыков, родом из Украины, директор
          по маркетингу ООО “Netpeak”, получивший Гран-При. В число сильнейших также вошли
          Игорь Луковский из Беларуси, Степанов Владислав из Армении и Парсаданишвили Георги
          из Грузии. Их объединяет не только статус лауреатов, но и сам тип профессионального
          мышления: каждый из них представляет маркетинг как систему, в которой стратегия,
          данные, бренд и бизнес-результат уже не существуют по отдельности.
        </p>

        <p className="p-1">
          Согласно критериям премии, в категории Best Marketer / «Лучший маркетолог»
          оценивались стратегический подход, креативность и инновации, измеримые результаты,
          лидерские качества, бюджетная эффективность, работа с данными и аналитикой, понимание
          целевой аудитории, а также этика и социальная ответственность. Это не конкурс отдельных
          кампаний, а профессиональная проверка уровня — того, насколько маркетолог способен
          мыслить широко, действовать точно и влиять на развитие бизнеса в долгую.
        </p>

        <p className="p-1">
          Редакции удалось собрать комментарии и подготовить специальный интервью-проект с
          победителями премии, чтобы увидеть не только итоговые результаты конкурса, но и то,
          как сами лауреаты понимают современный маркетинг, стратегию роста, роль аналитики и
          будущее индустрии. В центре этого разговора — обладатель Гран-При Роман Шлыков,
          а рядом с ним — другие сильнейшие представители профессионального сообщества,
          вошедшие в число лучших маркетологов 2020 года.
        </p>
      </div>

      <div className="block ">


        <div className="content p-20 wysiwyg">
          <p className="has-text-left p-style">Роман Шлыков, Украина, Обладатель Гран-При</p>

          <div>
          <img src={RomanImg} alt="Роман Шлыков (Roman Shlykov)" className="img_class mb-20" />
        </div>

          <p className="p-1">
            <strong>— Роман, если убрать из разговора слово “награда”, что на самом деле означает для вас эта победа?</strong>
          </p>
          <p className="p-1">
            — Это подтверждение того, что маркетинг может быть зрелой управленческой функцией.
            Не красивой надстройкой, не способом громче заявить о себе, а реальным механизмом
            влияния на бизнес, на восприятие бренда и на поведение аудитории. Для меня важно
            именно это. Когда твою работу признает международное профессиональное сообщество,
            ты понимаешь: оценен не только итог, но и способ мышления.
          </p>

          <p className="p-1">
            <strong>— Ваш проект звучит не как отдельная кампания, а как полноценная трансформация. Что именно вы подали на премию?</strong>
          </p>
          <p className="p-1">
            — Это был интегрированный digital-проект для крупной FMCG-розницы. Нам было важно
            не просто изменить коммуникационную оболочку бренда, а повлиять на то, как человек
            взаимодействует с ним на практике. Мы выстроили 360-градусную персонализацию:
            от мобильных триггеров до новых стандартов офлайн-коммуникации. Внутри проекта
            работали брендинг, CRM, PR, digital-экосистема, контент и сквозная аналитика.
            И главное — все это было собрано не в красивую презентацию, а в работающую систему.
          </p>

          <p className="p-1">
            <strong>— Что делает маркетинговую систему действительно сильной?</strong>
          </p>
          <p className="p-1">
            — Способность не разрывать логику. Когда бренд, данные, коммуникация и пользовательский
            опыт существуют как единая структура. Мы провели десятки интервью с клиентами, создали
            поведенческие сегменты, внедрили автоматизированную модель прогнозирования активности.
            В результате узнаваемость бренда выросла на 37%, NPS почти удвоился, а ROMI увеличился
            более чем в три раза. Для меня сильный маркетинг начинается именно там, где каждое
            решение имеет подтвержденное влияние.
          </p>

          <p className="p-1">
            <strong>— Часто говорят, что современные победы делаются командами, а не одиночками. Насколько это справедливо в вашем случае?</strong>
          </p>
          <p className="p-1">
            — Полностью. Маркетинг сегодня невозможно выиграть в одиночку. Это была работа
            18 человек: стратегов, аналитиков, UX-дизайнеров, PR-менеджеров, исследователей,
            разработчиков. Мы действовали в agile-формате, постоянно адаптировались по ходу проекта,
            и в какой-то момент стало ясно: сила не в количестве инструментов, а в том, насколько
            точно они собраны в одну цельную систему.
          </p>

          <p className="p-1">
            <strong>— Что изменила победа лично для вас?</strong>
          </p>
          <p className="p-1">
            — Она усилила масштаб разговора. После премии появились новые контакты, предложения
            о партнерствах, дополнительный интерес со стороны международного профессионального
            сообщества. Но, пожалуй, важнее даже не это. Важнее, что такие победы помогают
            закрепить правильное понимание профессии: маркетинг — это влияние, стратегия,
            дисциплина, а не просто рекламная активность.
          </p>
        </div>
      </div>

      <div className="block">


        <div className="content p-20 wysiwyg">
          <p className="has-text-left p-style">Игорь Луковский, Беларусь</p>

        <div>
          <img src={IgorImg} alt="Игорь Луковский" className="img_class mb-20" />
        </div>

          <p className="p-1">
            <strong>1 место: «Маркетинг должен работать тише, чем кажется, и сильнее, чем ожидается»</strong>
          </p>

          <p className="p-1">
            В профессиональном мире есть маркетологи, которые строят эффект через громкость, и есть
            те, кто предпочитает силу точности. Игорь Луковский — из второй категории. Как директор
            по маркетингу, он представляет тот тип управленца, для которого маркетинг — это не
            витрина, а механизм настройки бизнеса.
          </p>

          <p className="p-1">
            <strong>— Игорь, как вы сами определяете зрелый маркетинг?</strong>
          </p>
          <p className="p-1">
            — Для меня зрелый маркетинг — это тот, который помогает компании принимать более точные
            решения. Он не существует сам по себе, отдельно от продукта, продаж, репутации или
            операционной модели. Если маркетинг не влияет на бизнес-логику, значит, он еще не
            дорос до своей настоящей роли.
          </p>

          <p className="p-1">
            <strong>— Какой вызов вы считаете главным для современного маркетолога?</strong>
          </p>
          <p className="p-1">
            — Не потерять смысл в скорости. Сегодня все меняется быстро, и у специалистов возникает
            соблазн заменить стратегию реакцией. Но сильный маркетинг не в том, чтобы бежать первым.
            Он в том, чтобы точно понимать, куда вообще стоит бежать.
          </p>

          <p className="p-1">
            <strong>— Что вы считаете своим главным профессиональным принципом?</strong>
          </p>
          <p className="p-1">
            — Не путать движение с прогрессом. В маркетинге очень легко создавать видимость
            активности. Намного сложнее — построить систему, которая меняет поведение аудитории
            и усиливает позиции компании в долгую.
          </p>
        </div>
      </div>

      <div className="block">


        <div className="content p-20 wysiwyg">
          <p className="has-text-left p-style">Степанов Владислав, Армения</p>

                  <div>
          <img src={VladislavImg} alt="Владислав Степанов" className="img_class mb-20" />
        </div>

          <p className="p-1">
            <strong>2 место: «Маркетинг и развитие давно стали одной профессией»</strong>
          </p>

          <p className="p-1">
            Владислав Степанов, директор по маркетингу и развитию, представляет то поколение
            специалистов, для которых маркетинг уже не ограничивается коммуникацией. Это мышление
            роста, в котором рынок рассматривается как поле возможностей, а бренд — как инструмент
            масштабирования.
          </p>

          <p className="p-1">
            <strong>— Владислав, что сегодня важнее для маркетолога: уметь продвигать или уметь развивать?</strong>
          </p>
          <p className="p-1">
            — Уметь развивать. Продвижение — это лишь одна из форм выражения маркетинга. Настоящая
            ценность специалиста начинается там, где он может связать коммуникацию с ростом: с выходом
            в новые сегменты, с усилением позиции продукта, с изменением самого сценария потребления.
          </p>

          <p className="p-1">
            <strong>— Какой навык становится определяющим?</strong>
          </p>
          <p className="p-1">
            — Умение мыслить одновременно стратегически и прикладно. Сегодня недостаточно иметь
            хорошую идею. Нужно понимать, как она встроится в бизнес, как будет работать в реальности
            и как измерить ее результат.
          </p>

          <p className="p-1">
            <strong>— Можно ли сегодня быть сильным маркетологом без глубокой работы с аудиторией?</strong>
          </p>
          <p className="p-1">
            — Нет. Любая поверхностная коммуникация быстро проигрывает. Если ты не понимаешь, чего
            человек боится, чего ждет, на что надеется, как он принимает решение, ты говоришь не с ним,
            а рядом с ним.
          </p>
        </div>
      </div>

      <div className="block">
  

        <div className="content p-20 wysiwyg">
          <p className="has-text-left p-style">Парсаданишвили Георги, Грузия</p>

                <div>
          <img src={GeorgiImg} alt="Георги Парсаданишвили" className="img_class mb-20" />
        </div>

          <p className="p-1">
            <strong>3 место: «Лояльность рождается не в рекламе, а в последовательности опыта»</strong>
          </p>

          <p className="p-1">
            Должность Георги Парсаданишвили звучит почти как формула новой эпохи: директор по бренду
            и долгосрочной лояльности. В ней уже зашит главный сдвиг современного маркетинга: бренд
            больше нельзя строить отдельно от реального опыта клиента.
          </p>

          <p className="p-1">
            <strong>— Георги, как меняется понятие бренда сегодня?</strong>
          </p>
          <p className="p-1">
            — Бренд становится системой обещаний, которые нужно выполнять каждый день. Уже недостаточно
            быть узнаваемым. Нужно быть последовательным в сервисе, в интонации, в интерфейсах,
            в качестве контакта. Люди больше не разделяют образ и опыт. Для них это одно целое.
          </p>

          <p className="p-1">
            <strong>— Что сильнее влияет на долгосрочную лояльность — эмоция или полезность?</strong>
          </p>
          <p className="p-1">
            — Их нельзя разделить. Эмоция без полезности слишком быстро испаряется. Полезность без
            эмоции не создает привязанности. Лояльность появляется там, где человек регулярно получает
            предсказуемо хороший опыт и при этом чувствует, что бренд с ним говорит на его языке.
          </p>

          <p className="p-1">
            <strong>— Какая ошибка брендов сегодня самая опасная?</strong>
          </p>
          <p className="p-1">
            — Несоответствие между обещанием и реальностью. В эпоху прозрачности это разрушает
            доверие быстрее, чем любой конкурентный ход.
          </p>
        </div>
      </div>

      <div className="content p-20 wysiwyg">
        <p className="p-1">
          <strong>Что объединило лучших маркетологов 2020 года</strong>
        </p>

        <p className="p-1">
          На первый взгляд, Роман Шлыков, Игорь Луковский, Владислав Степанов и Георги
          Парсаданишвили представляют разные школы и разные управленческие акценты. Но если
          смотреть глубже, становится заметно главное: все они мыслят маркетинг как систему влияния.
        </p>

        <p className="p-1">
          Один делает ставку на интегрированную персонализацию и измеримый эффект. Другой —
          на стратегическую точность и роль маркетинга внутри бизнес-логики. Третий рассматривает
          маркетинг как двигатель развития. Четвертый делает центром силы доверие и долгосрочную
          лояльность. Разные формулы, но одна общая идея: маркетинг больше не живет в плоскости
          рекламной активности. Он работает там, где формируются решения, меняется поведение
          и создается рост.
        </p>

        <p className="p-1">
          Именно это видение и объясняет статус самой премии. В ее материалах подчеркивается,
          что победа означает международное признание, укрепляет профессиональный престиж,
          открывает новые горизонты для роста и помогает становиться ориентиром для других
          игроков рынка. Премия не просто отмечает успешные кейсы — она формирует представление
          о том, каким должен быть сильный маркетолог новой эпохи.
        </p>

        <p className="p-1">
          В этом смысле 2020 год оказался особенно показательным. Он показал, что лучший маркетинг —
          не самый шумный, а самый зрелый. Не самый визуально эффектный, а самый убедительный
          по последствиям. И если у этой истории есть одна ключевая фраза, то, возможно, она уже
          прозвучала в разговоре с обладателем Гран-При: маркетинг — это не реклама, а влияние.
        </p>
      </div>
    </div>
  );
}

export default ArticlePage18;